var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage1Lock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 141.6",
    style: {
      enableBackground: "new 0 0 140 141.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.532,
    y1: 140.7123,
    x2: 104.8108,
    y2: 1.6654,
    gradientTransform: "matrix(-1 0 0 1 134.5469 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6457A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AC7BB1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,0.6H43.2C19.4,0.6-0.1,20.1-0.1,43.9l0,54.6c0,23.8,19.5,43.3,43.3,43.3h53.4c23.8,0,43.3-19.5,43.3-43.3 l0-54.6C139.9,20.1,120.4,0.6,96.6,0.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.6,105H54.2c-8.9,0-16.1-7.2-16.1-16.1V76.7c0-8.9,7.2-16.1,16.1-16.1h31.4c8.9,0,16.1,7.2,16.1,16.1v12.2 C101.7,97.7,94.4,105,85.6,105z M54.2,64.6c-6.7,0-12.1,5.4-12.1,12.1v12.2c0,6.7,5.4,12.1,12.1,12.1h31.4 c6.7,0,12.1-5.4,12.1-12.1V76.7c0-6.7-5.4-12.1-12.1-12.1H54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.8,56.8c-0.2,0-0.3,0-0.5-0.1c-1.1-0.3-1.7-1.3-1.5-2.4c2.4-9.9,10.7-16.9,20.2-16.9 c9.2,0,17.4,6.7,20,16.2c0.3,1.1-0.3,2.2-1.4,2.5c-1.1,0.3-2.2-0.3-2.5-1.4C84,46.9,77.4,41.4,70,41.4c-7.6,0-14.3,5.7-16.3,13.8 C53.5,56.1,52.7,56.8,51.8,56.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1Lock);
export default __webpack_public_path__ + "static/media/Stage1_lock.dc7932619184eb908e4e65b3e01217b5.svg";
export { ForwardRef as ReactComponent };